import Vue from "vue";
import VueRouter from "vue-router";
import Idea from "@/views/Idea.vue";
import Problem from "@/views/Problem.vue";
import Solution from "@/views/Solution.vue";
import NextStepsAndTechnical from "@/views/NextStepsAndTechnical.vue";
import Login from "@/views/Login.vue";
import DocumentList from "@/views/DocumentList.vue";
import DocumentDetail from "@/views/DocumentDetail.vue";
import DocumentUpload from "@/views/DocumentUpload.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "DocumentList" }
  },
  {
    path: "/documents",
    name: "DocumentList",
    component: DocumentList
  },
  {
    path: "/documents/upload",
    name: "DocumentUpload",
    component: DocumentUpload
  },
  {
    path: "/documents/:docName",
    name: "DocumentDetail",
    component: DocumentDetail,
    props: true
  },
  {
    path: "/about/idea",
    name: "Idea",
    component: Idea
  },
  {
    path: "/about/problem",
    name: "Problem",
    component: Problem
  },
  {
    path: "/about/solution",
    name: "Solution",
    component: Solution
  },
  {
    path: "/about/next-steps-and-technical",
    name: "NextStepsAndTechnical",
    component: NextStepsAndTechnical
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  }
];

const router = new VueRouter({
  routes,
  linkExactActiveClass: "is-active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
